<div class="page-content container">
  <div class="page-header">
    <h1>
      {{ translationManager.getTranslation('Захтеви') }}
    </h1>
  </div>
  <div class="page-data shadow-sm">
    <div class="page-part">
      <div class="alert alert-info">
        <span><i class="fa fa-info-circle"></i>{{ translationManager.getTranslation('Страница за приказ свих захтева')
          }}</span>
      </div>
    </div>
    <div class="page-part" *ngIf="auth.isAuthorized('CFD353F6-09D8-4DB0-925F-AC76D0E9596E')">
      <div class="page-actions">
        <button class="btn btn-success" routerLink="./create"><i class="fa fa-plus mr-1"></i> {{
          translationManager.getTranslation('Додати нови захтев') }}</button>
      </div>
    </div>
    <div class="app-table-panel" app-table>
      <div class="app-table-used-filters">
        <div class="app-table-used-filters-title">
          <span>{{ translationManager.getTranslation('Искоришћени филтери') }}</span>
        </div>
        <div class="app-table-used-filter-items" search-tags>
          <div class="app-table-used-filter-items-no-content" search-tag-no-content>
            <span>{{ translationManager.getTranslation('Без искоришћених филтера') }}</span>
          </div>
          <div class="app-table-used-filter-item" style="display: none" search-tag-prototype>
            <span><i search-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                search-tag-prototype-value></i></span>
            <a href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер')"
              search-tag-prototype-close>
              <i class="fas fa-times"></i>
            </a>
          </div>
          <div class="app-table-used-filter-item app-table-used-filter-item-order" style="display: none"
            order-tag-prototype>
            <span><i order-tag-prototype-title></i><i class="app-table-used-filter-item-value"
                order-tag-prototype-value></i></span>
            <a href="javascript:;" [title]="translationManager.getTranslation('Обрисати филтер')"
              order-tag-prototype-close>
              <i class="fas fa-times"></i>
            </a>
          </div>
        </div>
      </div>
      <div class="app-table-filter-panel" filter>
        <div class="app-table-filter-icon">
          <a href="javascript:;" [title]="translationManager.getTranslation('Филтрирај ентитете')" filter-open>
            <i class="fas fa-filter"></i>
          </a>
        </div>
        <div class="app-table-filter">
          <div class="app-table-filter-search">
            <div class="app-table-filter-title">
              <span>{{ translationManager.getTranslation('Филтери') }}</span>
              <a href="javascript:;" [title]="translationManager.getTranslation('Затвори филтер')" filter-close>
                <i class="fas fa-times"></i>
              </a>
            </div>
            <div class="page-part">
              <div class="alert alert-info">
                <span><i class="fa fa-info-circle"></i>
                  {{ translationManager.getTranslation('Доступни филтери за процес филтрирања података') }}
                </span>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Број захтева') }}</label>
                <div class="app-form-element-content">
                  <input type="number" search-input search-entity="Id"
                    [search-title-new]="translationManager.getTranslation('Број захтева')" search-action="equals">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Категорија набавке') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="ProcurementCategory"
                    [search-title-new]="translationManager.getTranslation('Категорија набавке')"
                    search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('ЕЦМИД') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="EcmIds"
                    [search-title-new]="translationManager.getTranslation('ЕЦМИД')" search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Број тикета') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="TicketsIds"
                    [search-title-new]="translationManager.getTranslation('Број тикета')" search-action="contains">
                </div>
              </div>
            </div>

            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Организациона јединица') }}</label>
                <div class="app-form-element-content">
                  <input type="text" search-input search-entity="OrganizationalUnits"
                    [search-title-new]="translationManager.getTranslation('Организациона јединица')"
                    search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Датум креирања тикета') }}</label>
                <div class="app-form-element-content">
                  <input type="date" search-input search-entity="TicketsCreatedOn"
                    [search-title-new]="translationManager.getTranslation('Датум креирања тикета')"
                    search-action="contains">
                </div>
              </div>
            </div>
            <div class="page-part">
              <div class="app-form-element">
                <label>{{ translationManager.getTranslation('Статус захтева') }}</label>
                <app-multi-select [options]="requestStatuses" search-multiselect search-entity="RequestStatusName"
                  [search-title-new]="translationManager.getTranslation('Статус захтева')" search-action="equals">
                </app-multi-select>
              </div>
            </div>
            <div class="app-form-element-buttons">
              <button class="btn btn-success" do-search><i class="fa fa-check mr-2"></i>{{
                translationManager.getTranslation('Филтрирај') }}</button>
              <button class="btn btn-danger" reset-search><i class="fa fa-times mr-2"></i>{{
                translationManager.getTranslation('Поништи') }}</button>
            </div>
          </div>
        </div>
      </div>
      <div class="app-table">
        <table class="table table-striped text-dark-m1">
          <thead>
            <tr class="bgc-primary-tp2 text-white">
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по броју захтева')" order
                  order-entity="Id">
                  {{ translationManager.getTranslation('Број захтева') }}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по категорији набавке')"
                  order order-entity="ProcurementCategory">
                  {{ translationManager.getTranslation('Категорија набавке') }}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по ЕЦМИД-у тикета')" order
                  order-entity="EcmIds">
                  {{ translationManager.getTranslation('ЕЦМИД') }}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по броју тикета')" order
                  order-entity="TicketsIds">
                  {{ translationManager.getTranslation('Број тикета') }}
                </a>
              </th>
              <th>
                <a href="javascript:;"
                  [title]="translationManager.getTranslation('Сортирање по организационој јединици')" order
                  order-entity="OrganizationalUnits">
                  {{ translationManager.getTranslation('Организациона јединица') }}
                </a>
              </th>
              <th>
                <a href="javascript:;"
                  [title]="translationManager.getTranslation('Сортирање по датуму креирања тикета')" order
                  order-entity="TicketsCreatedOn">
                  {{ translationManager.getTranslation('Датум креирања тикета') }}
                </a>
              </th>
              <th>
                <a href="javascript:;" [title]="translationManager.getTranslation('Сортирање по статусу захтева')" order
                  order-entity="RequestStatusName">
                  {{ translationManager.getTranslation('Статус захтева') }}
                </a>
              </th>
              <th style="width: 100px" class="right">{{ translationManager.getTranslation('Акције') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of items">
              <td>{{item.id}}</td>
              <td>{{item.procurementCategory}}</td>
              <td>{{item.ecmIds}}</td>
              <td>{{item.ticketsIds}}</td>
              <td>{{item.organizationalUnits}}</td>
              <td>{{item.ticketsCreatedOn }}</td>
              <td>{{item.requestStatusName}}</td>
              <td class="right">
                <div class="table-actions">
                  <a *ngIf="auth.isAuthorized('7CFB5E47-8810-4C1E-A788-C74492765328') &&
                                            showButtonSendOpnForConfirmation(item.id) &&
                                            item.requestStatusUniqueId == requestStatusUniqueIdentifier.inProgress"
                    href="javascript:;" (click)="chooseModal(item.id,'onApproval',true)" class="blue"
                    [title]="translationManager.getTranslation('Пошаљи ОПН на потврду')">
                    <i class="fas fa-sign-in-alt"></i>
                  </a>

                  <a *ngIf="auth.isAuthorized('F1440F1C-7E8C-43A8-A999-80C6543E9389') &&
                                          item.requestStatusUniqueId == requestStatusUniqueIdentifier.onApproval"
                    [routerLink]="['./opn-review', item.id]"
                    [title]="translationManager.getTranslation('Преглед ОПН-а')">
                    <i class="fas fa-search"></i>
                  </a>

                  <a *ngIf="auth.isAuthorized('76FB53D9-53B6-4552-9319-E5936113C301') &&
                                        (item.requestStatusUniqueId == requestStatusUniqueIdentifier.onApproval ||
                                        item.requestStatusUniqueId == requestStatusUniqueIdentifier.changesBack)"
                    href="javascript:;" (click)="chooseModal(item.id,'rejected',true)" class="red"
                    [title]="translationManager.getTranslation('Одбијање ОПН-а')">
                    <i class="fas fa-sign-in-alt"></i>
                  </a>

                  <a *ngIf="auth.isAuthorized('D32CD9A9-BA74-412F-B4D1-8D4579369858')"
                    [routerLink]="['./details', item.id]" [title]="translationManager.getTranslation('Детаљи')">
                    <i class="far fa-file"></i>
                  </a>

                  <a *ngIf="auth.isAuthorized('CFD353F6-09D8-4DB0-925F-AC76D0E9596E') &&
                                      item.requestStatusUniqueId != requestStatusUniqueIdentifier.rejected"
                    [routerLink]="['./edit', item.id]" [title]="translationManager.getTranslation('Измена')">
                    <i class="far fa-file-alt"></i>
                  </a>

                  <a *ngIf="auth.isAuthorized('7716C85A-A67E-4F7E-85CC-224D83D5DA9B') &&
                                      item.requestStatusUniqueId == requestStatusUniqueIdentifier.inProgress"
                    href="javascript:;" (click)="chooseModal(item.id,'delete',true)" class="red"
                    [title]="translationManager.getTranslation('Брисање')">
                    <i class="far fa-trash-alt"></i>
                  </a>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="no-content" *ngIf="!items || items.length == 0">
          <span>{{ translationManager.getTranslation('Без података') }}</span>
        </div>
      </div>
      <div class="app-table-pagination">
        <div>
          <div pagination>
            <span>{{ translationManager.getTranslation('Страна') }}</span>
            <select pagination-pages>
              <option>1</option>
            </select>
            <span>{{ translationManager.getTranslation('од') }}</span>
            <span pagination-pages-count>-</span>
            <span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на почетак')"
                pagination-first-page>
                <i class="fas fa-angle-double-left"></i>
              </a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Претходна')" pagination-previous-page>
                <i class="fas fa-angle-left"></i>
              </a>
            </span>
            <span class="app-table-pagination-arrows">
              <a href="javascript:;" [title]="translationManager.getTranslation('Следећа')" pagination-next-page>
                <i class="fas fa-angle-right"></i>
              </a>
              <a href="javascript:;" [title]="translationManager.getTranslation('Иди на крај')" pagination-last-page>
                <i class="fas fa-angle-double-right"></i>
              </a>
            </span>
            <span>{{ translationManager.getTranslation('Број редова за приказ') }}</span>
            <select pagination-sizes>
              <option value="5">5</option>
              <option value="10">10</option>
              <option value="20">20</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
        <div class="app-table-pagination-sizes">
          <div>
            <span>{{ translationManager.getTranslation('Укупан број слогова') }}</span>
            <span pagination-total-count>-</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-modal [show]="showDeleteModal" (onHide)="chooseModal(0,'delete',false)"
  [title]="translationManager.getTranslation('Брисање захтева')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('Да ли сте сигурни да желите да обришете захтев?') }}</label>
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="delete()">
      <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="chooseModal(0,'delete',false)" class="btn btn-warning">
      <i class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>

<app-modal [show]="showSendOpnConfirmationModal" (onHide)="chooseModal(0,'onApproval',false)"
  [title]="translationManager.getTranslation('Пошаљи ОПН на потврду')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('Да ли сте сигурни да желите да пошаљете ОПН на потврду?') }}</label>
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="changeRequestOpnStatusApproved()">
      <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="chooseModal(0,'onApproval',false)" class="btn btn-warning">
      <i class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>



<app-modal [show]="showRejectionOpnModal" (onHide)="chooseModal(requestId,'rejected',false)"
  [title]="translationManager.getTranslation('Одбијање ОПН-а')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('Да ли сте сигурни да желите да одбијете ОПН-а?') }}</label>
  </div>
  <div class="app-modal-actions">
    <button class="btn btn-success" (click)="requestRejectMessage()">
      <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation('Да') }}</button>
    <button (click)="chooseModal(0,'rejected',false)" class="btn btn-warning">
      <i class="fa fa-times mr-2"></i>{{ translationManager.getTranslation('Не') }}</button>
  </div>
</app-modal>


<app-modal [show]="showRejectionOpnModalMsg" (onHide)="chooseModal(0,'rejectedMsg',false)"
  [title]="translationManager.getTranslation('Разлог одбијања ОПН-а')">
  <div class="app-modal-content">
    <label>{{ translationManager.getTranslation('Порука') }}</label>
    <textarea class="form-control" [(ngModel)]="message" style="height: 200px"></textarea>
  </div>
  <div class="app-modal-actions">
    <div class="form-element-buttons">
      <button class="btn btn-warning fl" (click)="chooseModal(0,'rejectedMsg',false)">
        <i class="fa fa-arrow-left mr-2"></i>{{ translationManager.getTranslation("Назад") }}
      </button>
      <button class="btn btn-success fr" (click)="RejectionOfOPNModal()">
        <i class="fa fa-check mr-2"></i>{{ translationManager.getTranslation("Сачувај") }}
      </button>
    </div>
  </div>
</app-modal>
